import { BehaviorSubject, distinctUntilChanged, map, skip } from 'rxjs';

export interface NotificationSession {
  key: string;
  accessToken: string;
}

const session = new BehaviorSubject<NotificationSession | null>(null);
export const notificationSession$ = session.asObservable();
export const notificationSessionChanged$ = notificationSession$.pipe(
  map((value) => value?.key ?? null),
  distinctUntilChanged(),
  skip(1),
);

/** Called only after authentication has verified/saved or cleared the session. */
export function publishNotificationSession(): void {
  try {
    const storage = globalThis.sessionStorage;
    const accessToken = storage?.getItem('accessToken');
    const user = JSON.parse(storage?.getItem('user') ?? 'null');
    if (!accessToken || typeof user?.userId !== 'string' || !user.userId) {
      session.next(null);
      return;
    }
    const roles = Array.isArray(user.roles)
      ? user.roles.filter((role: unknown) => typeof role === 'string').sort()
      : [];
    session.next({ key: JSON.stringify([user.userId, roles]), accessToken });
  } catch {
    session.next(null);
  }
}
